import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-gray-300 py-12">
      <motion.div 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="container mx-auto px-6 text-center"
      >
        <motion.div 
          className="flex justify-center items-center space-x-2 mb-4"
          whileHover={{ scale: 1.05 }}
        >
          <img 
            alt="Memic Logo" 
            className="h-10 w-20" 
            src="/images/memic_logo_3.png" 
          />
        </motion.div>
        <p className="mb-2">Bringing your chats to life, one AI avatar at a time.</p>
        <p className="text-sm">© 2025 Memic. All rights reserved.</p>
        <div className="mt-4 space-x-4">
          <Link to="/privacy-policy">
            <motion.span 
              whileHover={{ scale: 1.1, color: "#fff" }}
              className="hover:text-white transition-colors cursor-pointer" 
            >
              Privacy Policy
            </motion.span>
          </Link>
          <Link to="/terms-of-service">
            <motion.span 
              whileHover={{ scale: 1.1, color: "#fff" }}
              className="hover:text-white transition-colors cursor-pointer" 
            >
              Terms of Service
            </motion.span>
          </Link>
        </div>
      </motion.div>
    </footer>
  );
};

export default Footer; 